import React, { useState } from 'react';
import { Dashboard } from '@components/common/Dashboard';
import { Onboarding } from '@components/common/Onboarding';
import { PageLayout } from '@components/common/PageLayout';
import { useDashboardPermissions } from '@components/utils/DashboardPermissions';
import { ButtonClean } from '@fourthwall/components';
import { MiniRecommendations, MiniRecommendationsSkeleton, useMiniRecommendationsData, } from '@modules/Dashboard/modules/MiniRecommendations';
import { useCurrentShopQuery } from '../hooks/useCurrentShopQuery';
import { useHelpRecommendations, useRecommendations } from '../modules/Recommendations';
import { ArticleListSection } from './components/ArticleListSection';
import { Scheduler } from './components/Scheduler';
import { SectionTitle } from './components/SectionTitle';
import { useBlogPosts } from './hooks/useBlogPosts';
import { useHome } from './hooks/useHome';
import { useOnboarding } from './hooks/useOnboarding';
import { usePersonalizedRecommendations } from './hooks/usePersonalizedRecommendations';
import { HomeAnalytics } from './modules/HomeAnalytics';
import * as S from './styled';
export const Home = () => {
    const { name } = useHome();
    const { onboarding } = useOnboarding();
    const { hasPermission } = useDashboardPermissions();
    const { currentShopQuery } = useCurrentShopQuery();
    const { recommendations } = useRecommendations();
    const { blogPosts } = useBlogPosts();
    const { helpRecommendations } = useHelpRecommendations();
    const { isLoading: isMiniRecommendationsLoading, data: miniRecommendationsData } = useMiniRecommendationsData();
    const [showAllRecommendations, setShowAllRecommendations] = useState(false);
    const { personalizedRecommendations } = usePersonalizedRecommendations(recommendations);
    const visibleRecommendations = showAllRecommendations
        ? personalizedRecommendations
        : personalizedRecommendations.slice(0, 6);
    const hasMoreRecommendations = personalizedRecommendations.length > visibleRecommendations.length;
    const content = (['ONBOARDING_MEMBERSHIPS', 'NONE'].includes(onboarding.onboardingType) ||
        !!currentShopQuery.data?.lastLiveAt) &&
        hasPermission('home.analytics') && (React.createElement(S.Spacing, { space: "400" },
        React.createElement(HomeAnalytics, null)));
    return (React.createElement(PageLayout, null,
        React.createElement(Dashboard.Section, { name: name },
            React.createElement(S.Spacing, { space: "1200" },
                content,
                onboarding.schedulerProps && React.createElement(Scheduler, { ...onboarding.schedulerProps }),
                onboarding.onboardingProps && React.createElement(Onboarding, { ...onboarding.onboardingProps }),
                React.createElement("article", null,
                    onboarding.schedulerProps || onboarding.onboardingProps ? (React.createElement(SectionTitle, { title: "Next steps" })) : null,
                    React.createElement(S.MiniRecommendations, null, isMiniRecommendationsLoading ? (React.createElement(MiniRecommendationsSkeleton, null)) : (React.createElement(MiniRecommendations, { data: miniRecommendationsData, page: "home" }))),
                    visibleRecommendations.length > 0 && (React.createElement(S.Recommendations, null,
                        visibleRecommendations.map(({ suggestion, id }) => {
                            return (React.createElement(S.SuggestionWrapper, { key: `recommendation-${id}`, "data-analytics-section": id }, suggestion));
                        }),
                        hasMoreRecommendations && (React.createElement(S.ShowMoreRecommendationsButton, null,
                            React.createElement(ButtonClean, { label: "Show more recommendations", withUnderline: true, appearance: "secondary", onClick: () => setShowAllRecommendations(true) })))))),
                helpRecommendations.length > 0 && (React.createElement("article", null,
                    React.createElement(SectionTitle, { title: "Help & support" }),
                    React.createElement(S.Recommendations, null, helpRecommendations.map(({ suggestion, id }) => {
                        return (React.createElement(S.SuggestionWrapper, { key: `help-recommendation-${id}`, "data-analytics-section": id }, suggestion));
                    })))),
                blogPosts && React.createElement(ArticleListSection, { ...blogPosts })))));
};
